import createAction from '@wix/communities-blog-client-common/dist/src/services/create-action';

export const SET_ROUTER_MATCH = 'router/SET_MATCH';

export const setRouterMatch = createAction(SET_ROUTER_MATCH);
